export default __webpack_public_path__ + "static/2-33100ad34a12512ff52fc6c5553b5ee7.jpg";